import React, { useEffect, useCallback, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { showToast } from "../utils/utils";
import useMixpanelEventAction from "../config/mixpanel/useMixpanelEventAction";
import { verifyEmail } from "../locales/en";
import { getUserManagementVerifyEmailURL } from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";
import { INVOICE } from "../route/paths";

const VerifyConfirmationEmail = () => {
  const navigate = useNavigate();
  const initialRender = useRef(true);
  const { emailConfirmationMixpanelEvent } = useMixpanelEventAction();

  const { token } = useParams();

  const handleVerifyConfirmationEmail = useCallback(async () => {
    try {
      const response = await privateAxios.get(
        getUserManagementVerifyEmailURL(token)
      );
      if (response.status === 200) {
        emailConfirmationMixpanelEvent();
        showToast(verifyEmail.success, "success");
        navigate(INVOICE);
      }
    } catch {
      navigate(INVOICE);
    }
  }, [privateAxios, token, navigate, emailConfirmationMixpanelEvent]);

  useEffect(() => {
    if (initialRender.current) {
      handleVerifyConfirmationEmail();
      initialRender.current = false;
    }
  }, [handleVerifyConfirmationEmail]);

  return <h5 className="text-dark">{verifyEmail.text}</h5>;
};

export default VerifyConfirmationEmail;
